import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerRoutingModule } from './partner.routing.module';
import { AmbulanceComponent } from './ambulance/ambulance.component';
import { AmbulanceProfileEditComponent } from './ambulance-profile-edit/ambulance-profile-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { LabDashboardComponent } from './lab-dashboard/lab-dashboard.component';
import { TagInputModule } from 'ngx-chips';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AdminVerifyComponent } from '../components/admin-verify/admin-verify.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AmChartsModule } from '@amcharts/amcharts3-angular';
import { ResetpasswordpopupComponent } from '../components/resetpasswordpopup/resetpasswordpopup.component';
import { ReadMoreDirective } from '../see-more/see-more.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { GoogleMapsModule } from '@angular/google-maps';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TranslateModule } from '@ngx-translate/core';

// Replacements for abandoned packages
import { Ng2TelInputModule } from '../shared/ng2-tel-compat/ng2-tel-input.module';
import { SlideshowModule } from '../shared/slideshow/slideshow.module';
import { CKEditorModule } from '../shared/ckeditor-compat/ckeditor.module';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';

@NgModule({
  declarations: [
    ReadMoreDirective,
    AmbulanceComponent,
    AmbulanceProfileEditComponent,
    ResetpasswordpopupComponent,
    AdminVerifyComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PartnerRoutingModule,
    GooglePlaceModule,
    TagInputModule,
    RichTextEditorAllModule,
    CKEditorModule,
    TimepickerModule,
    ImageCropperModule,
    BsDatepickerModule.forRoot(),
    SlideshowModule,
    NgxSpinnerModule,
    Ng2TelInputModule,
    GoogleMapsModule,
    SlickCarouselModule,
    TranslateModule
  ],
  exports: [
    GoogleMapsModule,
    SlideshowModule,
    Ng2TelInputModule,
    CKEditorModule,
    AdminVerifyComponent,
    BsDatepickerModule,
    ResetpasswordpopupComponent,
    ReadMoreDirective
  ]
})
export class PartnerModule { }
